import { styled } from "styled-components";
import { Tab } from "@mui/material";

export const StyledTab = styled(Tab)`
  font-family: "Nunito", sans-serif !important;
  &.MuiButtonBase-root {
    font-weight: 900 !important;
  }
`;
